/* Scroll reveal: fade sections in as they enter, once, with no dependency.
   A progressive enhancement: without JS (or with reduced motion) the content
   stays fully visible; only the enhanced path opts into the hidden start state. */
function initReveal() {
  const items = [...document.querySelectorAll("[data-reveal]")];
  if (!items.length) return;
  const reduced = matchMedia("(prefers-reduced-motion: reduce)");
  if (reduced.matches || !("IntersectionObserver" in window)) return; // leave content visible
  // Opt into the hidden start state now that we can reliably reveal it.
  document.documentElement.classList.add("ap-reveal-ready");
  const io = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry, i) => {
      if (!entry.isIntersecting) return;
      setTimeout(() => entry.target.classList.add("is-revealed"), (i % 6) * 60);
      obs.unobserve(entry.target);
    });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
  items.forEach((el) => io.observe(el));
}

initReveal();
